import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M14 2a.667.667 0 01.667.667v10.666a.667.667 0 01-.666.667H2a.666.666 0 01-.667-.667V2.667A.667.667 0 012.001 2h12zm-.666 1.333H2.667v9.334h10.667V3.333zm-4.667 8V10h2V8h1.334v3.333H8.667zM7.334 4.667V6h-2v2H4.001V4.667h3.333z"
      ></path>
    </svg>
  )
}

export default Icon
